import axios from 'axios';

// API para PictogramLayerStatus
export function editPartialLayer(layerId, payload) {
  return axios.patch('/api/v2/pictogram-layer/' + layerId, payload);
}

export function readLayer(layerId, params) {
  return axios.get('/api/v2/pictogram-layer/' + layerId, { params: params });
}

export function getRatios(layerId) {
  return axios.get('/api/v2/pictogram-layer/' + layerId + '/ratios');
}

export function addRatio(layerId, payload) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/add-ratio', payload);
}

export function updateRatio(layerId, ratioId, payload) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/update-ratio/' + ratioId, payload);
}

export function deleteRatio(layerId, ratioId) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/delete-ratio/' + ratioId);
}

export function importExtraAttributes(layerId, payload) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/import-extra-attributes', payload);
}

// Resumen de atributos extra de una capa (totales + agrupación por pedido/línea).
export function getExtraAttributesSummary(layerId) {
  return axios.get('/api/v2/pictogram-layer/' + layerId + '/extra-attributes/summary');
}

// Listado paginado (server-side) de elementos con sus atributos extra.
export function getExtraAttributesList(layerId, params) {
  return axios.get('/api/v2/pictogram-layer/' + layerId + '/extra-attributes', { params });
}

// Persiste/versiona el Excel importado (aws_response del upload uppy + filename).
export function storeExtraAttributesDocument(layerId, payload) {
  return axios.post('/api/v2/pictogram-layer/' + layerId + '/extra-attributes/document', payload);
}

// Documento actual del import + historial de versiones.
export function getExtraAttributesDocument(layerId) {
  return axios.get('/api/v2/pictogram-layer/' + layerId + '/extra-attributes/document');
}
